import {
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { AccordionHeaderTitle } from 'component/Accordion';
import 'assets/styles/pages/lm-bm.scss';
import { Map } from 'component/Map';
import { React, useState, useEffect } from 'react';
import { pointGeometryToMapGeojson } from 'utils/Helper';
import { useBufferZone } from 'hooks/useBufferZone';
import { useHAReports } from 'hooks/useHAReports';
import { HASwitchers } from 'component/HASwitchers';
import { TableFileInfo } from './FileInformation/TableInfo';
import { LmBmInfo } from './FileInformation/LmBmInfo';
import { HazardAreaInfo } from './FileInformation/HazardAreaInfo';

export const FileInformation = (props) => {
  const [lmGeojson, setLmGeojson] = useState(props?.formData?.info?.lm?.geometry);
  const [bmGeojson, setBmGeojson] = useState(props?.formData?.info?.bm?.geometry);
  const fileZone = props?.formData?.info?.general?.file_zone ?? props?.formData?.file_zone;

  const localHaReports = useHAReports(props?.map || props?.map1);
  const haReports = props?.haReportsFileInfo || localHaReports;
  useBufferZone(props?.map || props?.map1);

  useEffect(() => {
    if (props?.formData?.info?.lm?.geometry?.coordinates?.length) {
      setLmGeojson(
        pointGeometryToMapGeojson(
          props?.formData?.info?.lm?.geometry?.coordinates,
          fileZone
        )
      );
    }
  }, [props?.formData?.info?.lm?.geometry, fileZone]);

  useEffect(() => {
    if (props?.formData?.info?.bm?.geometry?.coordinates?.length) {
      setBmGeojson(
        pointGeometryToMapGeojson(
          props?.formData?.info?.bm?.geometry?.coordinates,
          fileZone
        )
      );
    }
  }, [props?.formData?.info?.bm?.geometry, fileZone]);

  return (
    <>
      <AccordionItemHeading>
        <AccordionItemButton>
          <AccordionHeaderTitle
            accordionId={props?.accordionId}
            validationForm={props?.validationForm}
            block="file_info"
            titleUA={
              <div className="flex-group">
                <span>Інформація про полігон</span>
                <span className="star">*</span>
              </div>
            }
            titleEN="File information"
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="flex-column-group">
          {props?.tab !== 'gis' && (
            <HazardAreaInfo
              subAccordionId={5.1}
              formData={props?.formData}
              setFormData={props?.setFormData}
            />
          )}
          {props?.tab !== 'gis' && (
            <LmBmInfo
              formData={props?.formData}
              setFormData={props?.setFormData}
              handleTabChange={props?.handleTabChange}
              photos={props?.photos}
              setPhotos={props?.setPhotos}
              errors={props?.errors}
              setLoaderPhotos={props?.setLoaderPhotos}
            />
          )}
          <TableFileInfo formData={props?.formData} />
          {props?.tab !== 'gis' && (
            <div style={{ position: 'relative' }}>
              <HASwitchers
                {...haReports}
                googleWms={true}
                style={{
                  position: 'absolute',
                  top: '66px',
                  zIndex: 1,
                  background: 'rgba(255, 255, 255, 0.8)',
                  borderRadius: '4px',
                  padding: '0px 15px 7px 10px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  left: '0px',
                  borderRadius: '0 0 8px',
                  boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
                }}
              />
              <Map
                map={props?.map || props?.map1}
                setMap={props?.setMap || props?.setMap1}
                turnPointsPolygon={props?.formData?.info?.turn_points?.geojson}
                hazardAreaType={props?.formData?.info?.general?.hazard_area_type}
                lmGeojson={lmGeojson}
                bmGeojson={bmGeojson}
                haReportsPolygons={haReports?.haReportsPolygons}
                // azureLayerEnabled={haReports?.azureLayerEnabled}
                // setAzureLayerEnabled={haReports?.setAzureLayerEnabled}
                id="turnPoints-map"
                googleWms
              />
            </div>
          )}
        </div>
      </AccordionItemPanel>
    </>
  );
};
